import { render, staticRenderFns } from "./UNILORINTop.vue?vue&type=template&id=27d96337&"
import script from "./UNILORINTop.vue?vue&type=script&lang=js&"
export * from "./UNILORINTop.vue?vue&type=script&lang=js&"
import style0 from "./UNILORINTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports